import * as React from "react";

import { useParams } from "react-router-dom";
//gql-mui-rhf
import { createQuery } from "../../../utils/gql-mui-rhf/QueryAction";
import FirmProfile from "./profile";
import FirmUnits from "../FirmUnits/list";
import FirmPeople from "../FirmPeople";
// material
import {
  Box,
  Container,
  Typography,
  Tabs,
  Tab,
  CircularProgress,
} from "@mui/material";
// components
import Page from "../../../components/Page";

import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Link } from "react-router-dom";
// ----------------------------------------------------------------------

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const breadcrumbs = [
  <Link to="/app/admin/firms">Firms List</Link>,
  <Typography key="3" color="text.primary">
    Firm View
  </Typography>,
];

export default function FirmView() {
  const params = useParams();
  const firmId = params.id;
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const { loading, error, data } = createQuery("firm", { id: firmId });
  if (loading) return <CircularProgress />;
  if (error) {
    return <div>{`${error}`}</div>;
  }
  if (data) {
    return (
      <Page title="Dashboard | FINBACK670">
        <Container maxWidth="xl" style={{ paddingBottom: "64pt" }}>
          <Box sx={{ pb: 5 }}>
            <Typography variant="h4">{`Firm Management for ${data.firm.name}`}</Typography>
          </Box>
          <Box sx={{ pb: 5 }}>
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
            >
              {breadcrumbs}
            </Breadcrumbs>
          </Box>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab label="Firm Attributes" {...a11yProps(0)} />
              <Tab label="Firm Units" {...a11yProps(1)} />
              <Tab label="Firm People" {...a11yProps(2)} />
            </Tabs>
          </Box>
          <TabPanel value={value} index={0}>
            <Box sx={{ pb: 2 }}>
              <Typography variant="h5">{`Firm Attributes:`}</Typography>
            </Box>
            <FirmProfile firmId={firmId} />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <FirmUnits firmId={firmId} />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Box sx={{ pb: 2 }}>
              <Typography variant="h5">{`Firm People:`}</Typography>
            </Box>
            <FirmPeople firmId={firmId} />
          </TabPanel>
        </Container>
      </Page>
    );
  }
}
